var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.079,
    height: 60.361,
    viewBox: "0 0 69.079 60.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9029",
    "data-name": "Group 9029",
    transform: "translate(-3106.596 -305.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    transform: "translate(3106.596 320.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M3162.634,314.336a2.546,2.546,0,0,1,2.4,1.892c3.571,13.452,7.126,26.908,10.558,40.4a2.7,2.7,0,0,1-2.606,3.361c-16.029.025-53.074.014-64.015.011a2.378,2.378,0,0,1-2.29-3.006l10.937-40.767a2.378,2.378,0,0,1,2.287-1.769C3127.814,314.413,3159.043,314.26,3162.634,314.336Z",
    transform: "translate(-3106.595 -314.315)",
    fill: "#113252"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M3129.987,322.56a8.3,8.3,0,1,1,8.3-8.3A8.313,8.313,0,0,1,3129.987,322.56Zm0-14.1a5.8,5.8,0,1,0,5.8,5.8A5.807,5.807,0,0,0,3129.987,308.457Z",
    transform: "translate(11.392 0)",
    fill: "#113252"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightIcon);
export default __webpack_public_path__ + "static/media/weightIcon.6bc70b9002c875c7e429a24206d8e8b4.svg";
export { ForwardRef as ReactComponent };